'use strict';


import { Report } from './QAReport';
import { PublicLayers } from '../components/publicLayers/PublicLayers';
import { Environment } from '../components/Environment/Environment';

export class QAPublicLayers extends Report{
	constructor () {
		super('Public layers');
		
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		const checkLayers = ['highway','education','leisure','parks','railway','fun'];
		
		const scope = this;
		
		function checkEnvironment (env) {
			const id = env.type ? env.type : env.id;
			const type = id.toLowerCase();
			if (checkLayers.includes(type)) {
				const data = env.hasOwnProperty('data') ? env.data : env.objects;
				if (data && !data.length) {
					scope.addError(env,`${id} - is empty.`);
				}
			}
		}
		
		if (Environment.fromBundle()) {
			new Promise(resolve => {
				const awaitInterval = setInterval(() => {
					if (Environment.scope?.bundleLoaded) {
						clearInterval(awaitInterval);
						resolve(Environment.scope.environments);
					}
				},200);
			})
				.then(environments => {
					Object.values(environments).forEach(env => checkEnvironment(env));
					this.normalize();
					this.showReport();
				});
		} else if (PublicLayers.scope) {
			new Promise(resolve => {
				const awaitInterval = setInterval(() => {
					if (PublicLayers.layerScopes.length) {
						clearInterval(awaitInterval);
						resolve(PublicLayers.layerScopes);
					}
				}, 200);
			}).then(environments => {
				environments.forEach(env => checkEnvironment(env));
				this.normalize();
				this.showReport();
			});
		}
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => this.jsonReport.push(errorData.message));
		}
	}
	
}
